<template>
  <f7-page name="done"><!-- @page:beforeremove="onPageBeforeRemove" -->
    <f7-navbar id="navbar">
      <f7-nav-left>
        <img :src=$session_logo />
      </f7-nav-left>
      <f7-nav-right>
        <f7-link href="#" color="red" iconF7="xmark_square" icon-only @click="cancel"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-toolbar bottom>
      <small>{{ $t('copyright') }} ({{ progress }}/{{ $session_client_id }})</small>
    </f7-toolbar>

    <span v-if="progress==80">
      <f7-block>
         <Markdown :source="markdown" />
      </f7-block>
      <f7-list>
        <f7-list-item link="/register/">{{ $t('video-start') }}</f7-list-item>
      </f7-list>
    </span>

    <span v-if="progress==85">
      <f7-block-title>{{ $t('done-data_title') }}</f7-block-title>
        <f7-list>
          <f7-list-item :header="$t('done-cnp')" :title="national_id"></f7-list-item>
          <f7-list-item :header="$t('done-tel')" :title="user_phone_number"></f7-list-item>
          <f7-list-item :header="$t('done-email')" :title="user_email"></f7-list-item>
        </f7-list>
        <p>{{ $t('done-imagine_document_identitate') }}</p>
        <p>
          <img :src="s3_idcard" class="lazy lazy-fade-in" :style="img_style"/>
        </p>
        <p>{{ $t('done-imagine_selfie') }}</p>
        <p>
          <img :src="s3_selfie" class="lazy lazy-fade-in" :style="img_style"/>
        </p>
        <f7-list>
          <f7-list-item header="Cod" :title="otp_code"></f7-list-item>
        </f7-list>
        <p>{{ $t('done-imagine_video_1') }}</p>
        <p>
          <img :src="s3_video_face_1" class="lazy lazy-fade-in" :style="img_style"/>
        </p>
        <p>{{ $t('done-imagine_video_2') }}</p>
        <p>
          <img :src="s3_video_face_2" class="lazy lazy-fade-in" :style="img_style"/>
        </p>
        <p>{{ $t('done-imagine_video_3') }}</p>
        <p>
          <img :src="s3_video_face_3" class="lazy lazy-fade-in" :style="img_style"/>
        </p>
        <p>{{ $t('done-imagine_video_4') }}</p>
        <p>
          <img :src="s3_video_face_4" class="lazy lazy-fade-in" :style="img_style"/>
        </p>
        <span v-if="$session_client_id=='direct'">
          <f7-list>
            <f7-list-group>
              <f7-list-item>
                <span>{{ $t('done-agree') }}</span>
                <f7-toggle v-model:checked="agree" @change="agree_activate" name="agree" value="agree"></f7-toggle>
              </f7-list-item>
              <f7-list-item divider></f7-list-item>
              <f7-list-item link="#" :disabled="!agree" @click="activate" >{{ activate_btn_text }}</f7-list-item>
            </f7-list-group>
          </f7-list>
        </span>
        <span v-else>
          <f7-list>
            <f7-list-group>
              <f7-list-item link="#" @click="activate" >{{ activate_btn_text }}</f7-list-item>
            </f7-list-group>
          </f7-list>
        </span>
    </span>

    <span v-if="progress==90 && local_redirect==1">
      <f7-block>
         <Markdown :source="markdown" />
      </f7-block>
      <f7-list>
        <f7-list-item link="#" @click="cancel" >{{ $t('done-finalize_btn_text') }}</f7-list-item>
      </f7-list>
    </span>

  </f7-page>
</template>

<script>
  import { f7, f7ready } from 'framework7-vue'; 
  import { request } from 'framework7';
  import Markdown from 'vue3-markdown-it';

  const vw=0.98*Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
  const vh=0.98*Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

  export default {
    props: {
      f7route: Object,
      f7router: Object,
    },
    components: {
      Markdown,
    },
    data() {
      return {
        agree: false,
        user_email: null,
        user_email_verified: null,
        national_id: null,
        user_phone_number: null,
        user_phone_number_verified: null,
        otp_code: null,
        s3_video: null,
        s3_selfie: null,
        ch: vh,
        cw: vw,
        s3_idcard: null,
        s3_video_face_1: null,
        s3_video_face_2: null,
        s3_video_face_3: null,
        s3_video_face_4: null,
        progress: null,
        registered: null,
        markdown: '',
        get token() {
          return localStorage.getItem('token');
        },
        set token(value) {
          localStorage.setItem('token', value);
        },
        redirect_to: null,
        local_redirect: 0,
        http500_show_alert: true,
      };
    },
    computed: {
      img_style: function() {
        const self=this;
        return "max-width:"+self.cw+"px;max-height:"+self.ch+"px;padding:2px 2px 2px 2px;";
      },
      activate_btn_text: function() {
        const self=this;
        if(self.$session_client_id=='direct')
          if(self.agree) {
            return self.$t('continue');
          } else {
            return self.$t('done-must_agree');
          }
        return self.$t('continue');
      },
      title_popup: function() {
        const self=this;
        if(self.registered==0)
          return self.$t('error');
        else
          return self.$t('success');
      },
    },
    mounted() {
      const self=this;
      if (localStorage.progress) {
        self.progress=localStorage.progress;
      }
      self.status();
    },
    methods: {
      agree_activate(event) {
        const self=this;
        self.agree=event.target.checked;
      },
      activate() {
        const self=this;
        f7.preloader.show();
        request({
          beforeSend: function (xhr) {
            xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
          },
          method: 'post',
          url: '/v/activate',
          success: function (data, status, xhr) {
            f7.preloader.hide();
            if(data.pass) {
              self.registered=data.registered;
              self.markdown=data.markdown;
              self.progress=data.progress;
              self.redirect_to=data.redirect_to;
              self.local_redirect=data.local_redirect;
              if(self.local_redirect==0) {
                self.cleanup();
                window.location.href=self.redirect_to;
              }
            } else {
              console.log('196 error');
            }
          },
          error: function (xhr, status, message) {
            f7.preloader.hide();
            self.http500(status, message);
            if(self.http500_show_alert)
              f7.dialog.alert('('+status+') '+message, self.$t('error'));
          },
          dataType: 'json'
        });
      },
      status() {
        const self=this;
        f7.preloader.show();
        request({
          beforeSend: function (xhr) {
            xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
          },
          method: 'post',
          url: '/v/status',
          data: { 
            'info':1,
          },
          success: function (data, status, xhr) {
            f7.preloader.hide();
            if(data.pass) {
              self.registered=data.registered;
              if(self.registered==0) {
                self.progress=data.progress;
                self.registered=data.registered;
                self.user_email=data.user_email;
                self.user_email_verified=data.user_email_verified;
                self.national_id=data.national_id;
                self.user_phone_number=data.user_phone_number;
                self.user_phone_number_verified=data.user_phone_number_verified;
                self.otp_code=data.otp_code;
                self.s3_video=data.s3_video;
                self.s3_selfie=data.s3_selfie;
                self.s3_idcard=data.s3_idcard;
                self.s3_video_face_1=data.s3_video_face_1;
                self.s3_video_face_2=data.s3_video_face_2;
                self.s3_video_face_3=data.s3_video_face_3;
                self.s3_video_face_4=data.s3_video_face_4;
                self.ch=Math.min(vh,data.h);
                self.cw=Math.min(vw,data.w);
              }
              self.markdown=data.markdown;
              if(data.progress==90) {
                localStorage.clear();
                if(data.local_redirect==0) {
                  self.cleanup();
                  window.location.href=data.redirect_to;
                }
              }
            } else {
              console.log("252 error");
            }
          },
          error: function (xhr, status, message) {
            f7.preloader.hide();
            self.http500(status, message);
            if(self.http500_show_alert)
              f7.dialog.alert('('+status+') '+message, self.$t('error'));
          },
          dataType: 'json'
        }); 
      },
      cancel() {
        const self=this;
        console.log("266 cancel");
        if(self.progress==90) {
          self.cleanup();
          window.location.href='/';
        } else {
          f7.dialog.confirm(
            self.$t('cancel-text'),
            self.$t('cancel'),
            ()=> {
              f7.preloader.show();
              request({
                beforeSend: function (xhr) {
                  xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
                },
                method: 'post',
                url: '/v/cancel',
                success: function (data, status, xhr) {
                  f7.preloader.hide();
                  localStorage.clear();
                  localStorage.token=data.token;
                  if(data.local_redirect==0)
                    window.location.href=data.redirect_to;
                  else
                    self.f7router.navigate(data.redirect_to);
                },
                error: function (xhr, status, message) {
                  f7.preloader.hide();
                  self.http500(status, message);
                  if(self.http500_show_alert)
                    f7.dialog.alert('('+status+') '+message, self.$t('error'));
                },
                dataType: 'json'
              });
            }
          );
        }
      },
      cleanup() {
        localStorage.clear();
        delete self.progress;
        delete self.registered;
        delete self.user_email;
        delete self.user_email_verified;
        delete self.national_id;
        delete self.user_phone_number;
        delete self.user_phone_number_verified;
        delete self.otp_code;
        delete self.s3_video;
        delete self.s3_selfie;
        delete self.s3_idcard;
        delete self.s3_video_face_1;
        delete self.s3_video_face_2;
        delete self.s3_video_face_3;
        delete self.s3_video_face_4;
        delete self.ch;
        delete self.cw;
      },
      // 500 status
      http500(status, message) {
        const self=this;
        self.http500_show_alert=true;
        switch(status) {
          case 500: 
            self.http500_show_alert=false;
            self.f7router.navigate('/error',{props:{status, message}});
            break;
          case 419:
            self.http500_show_alert=false;
            self.f7router.navigate('/expired');
            break;
        }
      },
      onPageBeforeRemove() {
        const self=this;
        console.log("340 finish.");
        // if(self.popup) self.popup.destroy();
      },
    },
  };  
</script>
